import useSWR from 'swr';
import useQuery from './useQuery';
import { fetchData, getConfigurationEnv } from '@/utils';

export const useUserData = () => {
  const query = useQuery();

  const token = query?.get('token');

  const data = useSWR(
    token ? 'user-info' : null,
    async () =>
      await fetchData(`${getConfigurationEnv('VITE_API')}/users/me?legacy_token=${token}`, '').then(
        (data) => {
          return data as {
            capitalizedName?: string;
            fullName?: string;
            rankName?: string;
            imageUrl?: string;
            profileURL?: string;
            regNumber?: string;
            mobile?: string;
            eraUserId?: string;
            realtywatchURL?: string;
            vcardURL?: string;
          };
        },
      ),
  );

  return data.data;
};
